import React from "react";
import { Box } from "@mui/material";
import ServerErrorPageComponent from "../../components/error-pages/5xx";

function ServerErrorPage() {
  return <Box>{<ServerErrorPageComponent />}</Box>;
}

export default ServerErrorPage;
